export class CreateEventController {
  constructor($scope, $rootScope, $http, $location, toastr, UserService, EventService, RegionService, CityService) {
    $scope.vm = this;
    $scope.regions = [];
    $scope.allCities = [];
    $scope.cities = [];
    $scope.event = {};
    $scope.limits = {
      min: 18,
      max: 99,
      from: 18,
      to: 99,
      type: "double",
      postfix: "años"
    };

    $scope.eventTypes = [];
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.http = $http;
    this.location = $location;
    this.toastr = toastr;
    this.EventService = EventService;
    this.UserService = UserService;
    this.RegionService = RegionService;
    this.CityService = CityService;
    this.scope.isVip = false;
    this.init();
  }

  init() {
    this.scope.isLoadedPage = false;
    this.scope.isVip = () => this.rootScope.isVip() && this.rootScope.currentUserProfile.usertype === +'4';

    this.RegionService.getRegionsList()
    .then((response) => { let regions = response.data;
      this.scope.regions = regions.data;
    })
    .catch((response) => { let error = response.data;
      console.log("Can`t get regions from database");
    });

    this.CityService.getCitiesList()
    .then((response) => { let cities = response.data;
      this.scope.allCities = cities.data;
    })
    .catch((response) => { let error = response.data;
      console.log("Can`t get cities from database");
    });

    this.scope.changeRegion = () => {
      this.scope.cities = [];
      this.scope.event.city = null;

      var region = this.scope.event.region;

      _(this.scope.allCities).forEach((city) => {
        if(city.region == region) {
          this.scope.cities.push(city);
        }
      }).value();
    }

    this.EventService.getTypes()
    .then((response) => { let types = response.data;
      this.scope.eventTypes = types.data;
      this.scope.event.eventType = "" + this.scope.eventTypes[0]._id;
    })
    .catch((response) => { let error = response.data;
      console.log("Can`t get event types from database");
    });

    this.scope.change = (sliderObj) => {
      this.scope.limits.from = sliderObj.from;
      this.scope.limits.to = sliderObj.to;
    }

    this.UserService.getCurrentUser()
    .then((response) => { let user = response.data;
      this.rootScope.currentUserProfile = user.data;
      this.scope.isLoadedPage = true;
    })
    .catch((response) => { let error = response.data;
      this.scope.isLoadedPage = true;
      console.log(error);
    });
  }

  addEvent(eventForm) {
    if(!this.rootScope.isVip()) {
      this.toastr.error('Usted no se ha VIP añadir evento');
      return;
    }

    if(this.formValidation(eventForm)) {
      this.scope.event.userID = this.rootScope.currentUserProfile._id;
      this.scope.event.minAge = this.scope.limits.from;
      this.scope.event.maxAge = this.scope.limits.to;

      var parts = this.scope.event.filter.date.split(".").map(Number);
      this.scope.event.date = new Date(parts[2], parts[1] - 1, parts[0], 0, 0, 0);

      var hourFrom = this.scope.event.filter.hourFrom.split(":").map(Number);
      this.scope.event.hourFrom =  new Date(this.scope.event.date.setHours(hourFrom[0], hourFrom[1]));

      var hourTo = this.scope.event.filter.hourTo.split(":").map(Number);
      if(hourFrom[0] > hourTo[0]){
        this.scope.event.hourTo = new Date(parts[2], parts[1] - 1, parts[0] + 1, hourTo[0], hourTo[1], 0);
      } else {
        this.scope.event.hourTo =  new Date(this.scope.event.date.setHours(hourTo[0], hourTo[1]));
      }

      let newEvent = JSON.stringify(this.scope.event);

      this.EventService.createEvent(newEvent)
        .then((response) => { let data = response.data;
          alert('Tu evento ha sido creado pero debe ser aprobado por el Administrador para ser publicado.');
          this.location.path('/eventord');
          console.log('Send event to server');

        })
        .catch((response) => { let error = response.data;
          console.log(error);
          this.location.path('/eventord');
        });
    }
  }

formValidation(form){
  if(!form.$valid){
    Object.keys(form).every((key, index, value) => {
      let findErr = true;
      switch (key) {
        case 'title':
          if(form[key].$invalid){
            this.toastr.error('Debes indicar el titulo del evento');
            break;
          }
        case 'region':
          if(form[key].$invalid){
            this.toastr.error('Usted tiene que especificar la región');
            break;
          }
        // case 'ciudad':
        //   if(form[key].$invalid){
        //     this.toastr.error('Debe especificar la ciudad');
        //     break;
        //   }
        case 'description':
        if(form[key].$invalid){
          this.toastr.error('Debes indicar la descripción del evento');
          break;
        }
        case 'place':
          if(form[key].$invalid){
            this.toastr.error('Debes indicar el lugar en donde se realizara el evento (Mi casa, Bar, etc)');
            break;
          }
        case 'address':
          if(form[key].$invalid){
            this.toastr.error('Debes indicar la direccion del lugar en donde se realizara el evento');
            break;
          }
        case 'date':
          if(form[key].$invalid){
            this.toastr.error('Debes indicar una fecha valida para la fecha de realizacion del evento');
            break;
          }
        case 'hourFrom':
          if(form[key].$invalid){
            this.toastr.error('Debes indicar el horario de inicio del evento');
            break;
          }
        case 'hourTo':
          if(form[key].$invalid){
            this.toastr.error('Debes indicar el horario de termino del evento');
            break;
          }
        case 'regToDate':
          if(form[key].$invalid){
            this.toastr.error('Debes indicar una fecha valida para la fecha de cierre');
            break;
          }
        case 'places':
          if(form[key].$invalid){
            this.toastr.error('El cupo de participantes debe ser mayor que 2 y menor que 999');
            break;
          }
        case 'costByMale':
          if(form[key].$invalid){
            this.toastr.error('Debes indicar el precio para hombres');
            break;
          }
        case 'costByFemale':
          if(form[key].$invalid){
            this.toastr.error('Debes indicar el precio para mujeres');
            break;
          }
        case 'costByGender':
          if(form[key].$invalid){
            this.toastr.error('Debes indicar el precio');
            break;
          }
        default:
          findErr = false;
          break;
      }
      if(findErr){
        $('form[name="'+ form.$name +'"] * [name="'+ key +'"]')[0].focus();
        return;
      }
      return key.length;
    });

    return;
  }
    return true;
  }
}
